import { useTheme } from "../context/context"

export default function BasicTable(props){
    const {fontSize} = useTheme();
    return(
        <>
            <table width="100%" >
                <tr bgColor="#d2ded7" >
                    {props.heading?.map(val=> <th key={val.data} width={val.width} style={{fontSize:`${fontSize}rem`,textAlign:"left", padding:"5px",border:"1px solid lightgray"}} >{val.data}</th>)}
                </tr>
                {
                    props?.data?.map((val)=>{
                        return(
                            <tr key={val[0]}>
                                {val?.map(value=><td key={value} style={{ padding:"5px", fontSize:`${fontSize}rem`,border:"1px solid lightgray"}}>{value}</td>)}
                            </tr>
                        )
                    })
                }
            </table>
        </>
    )
}